export enum ContextualMenuActions {
    Edit = 0,
    Delete = 1,
    MarkAsMain = 2,
}
